import glamorous from 'glamorous'

export const StyledInputWrapper = glamorous.div({
  overflow: 'hidden',
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Input/InputWrapper.glamorous.tsx